/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  launchRocket: {
    defaultMessage: 'Launch Rocket',
    id: 'app.launching.rocket.text'
  }
});



// WEBPACK FOOTER //
// ./src/containers/launching-rocket/messages.js